import { render, staticRenderFns } from "./ActiveSkills.vue?vue&type=template&id=b8db4874&"
import script from "./ActiveSkills.vue?vue&type=script&lang=js&"
export * from "./ActiveSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports